import Component from "./message";

import {bindActionCreators} from "redux";
import {push, pop} from '../../store/actions/message';
import connect from "react-redux/es/connect/connect";



function mapStateToProps(state) {
    const message = state.message;

    return {
        message
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({push, pop}, dispatch);
}

export const Message = connect(mapStateToProps, mapDispatchToProps)(Component);